import parkRoutes from './routes'

/* @ngInject */
const parkRoute = (
  $stateProvider
) => {
  $stateProvider
    .state(parkRoutes.index.path, {
      url: parkRoutes.index.url,
      template: require('./templates/index.html'),
      controller: 'parkCtrl',
    })
}

export default parkRoute



// WEBPACK FOOTER //
// ./public/javascript/sygem/routing/maneuver/park/park.routes.js